var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMomentoTensorBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,12a244.06,244.06,0,0,1,95,468.83A244.06,244.06,0,0,1,161,31.18,242.31,242.31,0,0,1,256,12m0-10C115.77,2,2,115.75,2,256.06S115.77,510,256,510,510.05,396.28,510.05,256.06,396.31,2,256,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.33,
    y: 306.3,
    width: 122.14,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.33 332.08 139.32 332.08 139.32 342.08 361.18 342.08 361.18 341.49 361.18 341.49 361.18 331.49 139.33 331.49 139.33 332.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.33 357.26 139.32 357.26 139.32 367.26 361.18 367.26 361.18 366.67 361.18 366.67 361.18 356.67 139.33 356.67 139.33 357.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.33 382.45 139.32 382.45 139.32 392.45 361.18 392.45 361.18 391.86 361.18 391.86 361.18 381.86 139.33 381.86 139.33 382.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.67,220a101.24,101.24,0,0,0-45.07-84.21V72.35H174.29a5,5,0,0,0-3.54,1.46l-52,52a5,5,0,0,0-1.34,4.6h-.12V441.65H383.6V304.24A101.23,101.23,0,0,0,428.67,220ZM240,246.3c18.27-32,43.35-54.39,74.59-66.56a129.6,129.6,0,0,1,37.22-8.62C343,241.93,314.47,296,307.1,309A91.61,91.61,0,0,1,240,246.3ZM352.8,132.36c.41,5.56.88,14.15.81,21.47-13.11-11.34-34.53-18.05-50.68-21.73a91.61,91.61,0,0,1,49.87.26ZM412.89,252c-2.74-21.53-12.47-54.56-44.21-83.15,16.71-2,31.88,1.81,36.24,3.06a91.17,91.17,0,0,1,8,80.09ZM169.29,89.42v34.89H134.4ZM373.6,431.65H127.33V134.31h47a5,5,0,0,0,5-5v-47H373.6v47.58a101.16,101.16,0,0,0-90.74-.82,4.5,4.5,0,0,0-.73.36A102,102,0,0,0,237.75,173H212.09a2.5,2.5,0,0,0-2.46,2l-2.36,12.9-11-35.91a2.46,2.46,0,0,0-2.5-1.77,2.51,2.51,0,0,0-2.34,2l-9.09,44.13-3.71-24.33a2.49,2.49,0,0,0-2.47-2.12H139.33v5H174l5.48,36a2.49,2.49,0,0,0,2.4,2.12H182a2.5,2.5,0,0,0,2.45-2l9.94-48.21,11.11,36.38A2.53,2.53,0,0,0,208,201a2.5,2.5,0,0,0,2.31-2.05l3.83-21h21.12a100.68,100.68,0,0,0-9.15,42c0,.43,0,.86,0,1.3H139.33v10h87.44a100,100,0,0,0,2.89,15.18H139.33v10h93.61a101.58,101.58,0,0,0,75.6,63,3.12,3.12,0,0,0,.44.09,101.38,101.38,0,0,0,64.62-9.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomentoTensorBlanco);
export default __webpack_public_path__ + "static/media/momento_tensor_blanco.b1121294cd6b78a1234cbe6b69d9f4c5.svg";
export { ForwardRef as ReactComponent };